const smtRightNav = {
  titleTop: {
    color: {
      default: 'gray.800',
      _dark: 'gray.200'
    }
  },
  link: {
    active: {
      color: {
        default: 'brand.500',
        _dark: 'brand.300'
      }
    },
    inactive: {
      color: {
        default: 'gray.800',
        _dark: 'gray.400'
      }
    }
  }
};

export default smtRightNav;
